import tw, { styled } from 'twin.macro';
import { linkIconStyles, variants } from '@/components/Link/Link.styles';

export const Wrapper = styled.div`
  ${tw`hidden md:block`}
`;

export const Button = styled.button`
  ${variants.tertiary}
  ${linkIconStyles}
  ${tw`flex`}
  ${tw`items-center`}
`;
